<template>
  <base-modal-component>
    <template v-slot:header>
      <h4 class="md-title u-typography-color">
        Translations for <code class="c-list-translations__key">{{ word.key }}</code>
      </h4>
    </template>

    <template v-slot:body>
      <md-table class="c-list-translations">
        <md-table-row>
          <md-table-head>Language</md-table-head>
          <md-table-head>Translation</md-table-head>
          <md-table-head>Exceptions</md-table-head>
        </md-table-row>
        <md-table-row
          v-for="(translationGroup, index) in formattedTranslations"
          :key="index"
        >
          <md-table-cell>{{ translationGroup.languageName }}</md-table-cell>
          <md-table-cell>
            <span v-if="translationGroup.translations && translationGroup.translations.phrase">{{ translationGroup.translations.phrase }}</span>
            <span
              v-else
              class="c-list-translations__missing"
            >Not translated</span>
          </md-table-cell>
          <md-table-cell>
            <div v-if="translationGroup.exceptions && translationGroup.exceptions.length">
              <p
                v-for="exception in translationGroup.exceptions"
                :key="exception.id"
                class="c-list-translations__exception"
              >
                <span>{{ exception.website.url }}</span>
                {{ exception.phrase }}
              </p>
            </div>
            <span
              v-else
              class="c-list-translations__missing"
            >—</span>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </template>

    <template v-slot:footer>
      <generic-button
        variation="grey"
        @click="close()"
      >
        Close
      </generic-button>
    </template>
  </base-modal-component>
</template>

<script>
import {forEach} from "lodash";
import find from "lodash/find";
import filter from "lodash/filter";
import GenericButton from "../../../../../../shared/buttons/GenericButton";
import BaseModalComponent from "../../../../../../shared/modal/BaseModalComponent";


export default {
  name: "ListTranslationModal",
  components: {
    GenericButton,
    BaseModalComponent,
  },
  props: {
    translations: {
      type: Array,
      required: true,
    },
    exceptions: {
      type: Array,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
    word: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      formattedTranslations: []
    }

  },

  created() {
    forEach(this.languages, language => {
      const findTranslations = find(this.translations, (translation) => translation.language.id === language.id );
      const findExceptions = filter(this.exceptions, (exception) => exception.languageId === language.id );
      if(!findTranslations && (!findExceptions || !findExceptions.length)) {
        return
      }
      this.formattedTranslations.push({
        languageName: language.name,
        translations: findTranslations,
        exceptions: findExceptions,
      })
    })
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.c-list-translations__key {
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  background-color: var(--bg-subtle);
  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
  font-size: 14px;
  font-weight: 500;
}

.c-list-translations__missing {
  color: var(--text-muted);
  font-style: italic;
}

.c-list-translations__exception {
  margin: 0 0 4px;

  span {
    display: block;
    font-size: 12px;
    color: var(--text-muted);
  }
}
</style>
